export const planPdfLayout = (elements, { pageWidth, pageHeight, padding }) => {
  const contentWidth = pageWidth - padding * 2;
  const usableHeight = pageHeight - padding * 2;

  const placements = [];
  let page = 0;
  let top = padding;

  const place = (placement) => {
    if (top > padding && top + placement.height > pageHeight - padding) {
      page += 1;
      top = padding;
    }

    placements.push({ ...placement, page, x: padding, y: top });
    top += placement.height + padding;
  };

  elements.forEach(({ width, height }, index) => {
    if (!width || !height) return;

    const scale = Math.min(1, contentWidth / width);
    const drawWidth = width * scale;
    const drawHeight = height * scale;

    if (drawHeight <= usableHeight) {
      place({
        index,
        part: 0,
        width: drawWidth,
        height: drawHeight,
        sourceTop: 0,
        sourceHeight: height,
      });
      return;
    }

    const bandHeight = usableHeight / scale;
    let part = 0;

    for (let sourceTop = 0; sourceTop < height; sourceTop += bandHeight) {
      const sourceHeight = Math.min(bandHeight, height - sourceTop);

      place({
        index,
        part,
        width: drawWidth,
        height: sourceHeight * scale,
        sourceTop,
        sourceHeight,
      });

      part += 1;
    }
  });

  return placements;
};
